export interface LocationStructure {
  [country: string]: {
    [state: string]: string[];
  };
}

export const locationMaster: LocationStructure = {
  "India": {
    "Andhra Pradesh": [
      "Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Tirupati", 
      "Kurnool", "Kakinada", "Rajamahendravaram", "Kadapa", "Anantapur", 
      "Eluru", "Vizianagaram", "Proddatur", "Nandyal", "Adoni", "Madanapalle", 
      "Chittoor", "Ongole", "Machilipatnam", "Tenali"
    ],
    "Assam": [
      "Guwahati", "Dibrugarh", "Silchar", "Jorhat", "Nagaon", 
      "Tinsukia", "Tezpur", "Bongaigaon", "Goalpara", "Sibsagar",
      "Karimganj", "Dhubri", "Barpeta", "Diphu", "North Lakhimpur"
    ],
    "Bihar": [
      "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia", 
      "Darbhanga", "Bihar Sharif", "Arrah", "Begusarai", "Katihar", 
      "Munger", "Chhapra", "Bettiah", "Saharsa", "Sasaram", "Hajipur",
      "Dehri", "Siwan", "Motihari", "Nawada"
    ],
    "Chandigarh": ["Chandigarh"],
    "Chhattisgarh": [
      "Raipur", "Bhilai", "Bilaspur", "Korba", "Rajnandgaon", 
      "Jagdalpur", "Ambikapur", "Dhamtari", "Raigarh", "Mahasamund"
    ],
    "Delhi": [
      "New Delhi", "Delhi", "Dwarka", "Rohini", "Narela", 
      "Vasant Kunj", "Mayur Vihar", "Janakpuri", "Karol Bagh", "Connaught Place"
    ],
    "Goa": ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda", "Bicholim", "Curchorem"],
    "Gujarat": [
      "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar", 
      "Bhavnagar", "Jamnagar", "Junagadh", "Anand", "Navsari", 
      "Morbi", "Nadiad", "Surendranagar", "Bharuch", "Vapi", "Valsad",
      "Porbandar", "Godhra", "Patan", "Mehsana", "Bhuj"
    ],
    "Haryana": [
      "Gurugram", "Faridabad", "Panipat", "Ambala", "Karnal", 
      "Rohtak", "Hisar", "Sonipat", "Yamunanagar", "Panchkula",
      "Sirsa", "Bahadurgarh", "Jind", "Thanesar", "Kaithal"
    ],
    "Himachal Pradesh": ["Shimla", "Dharamshala", "Solan", "Mandi", "Nahan", "Una", "Chamba", "Hamirpur", "Kullu", "Bilaspur"],
    "Jammu and Kashmir": ["Srinagar", "Jammu", "Anantnag", "Baramulla", "Kathua", "Sopore", "Udhampur", "Sambha", "Poonch"],
    "Jharkhand": [
      "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar", 
      "Phusro", "Hazaribagh", "Giridih", "Ramgarh", "Medininagar"
    ],
    "Karnataka": [
      "Bengaluru", "Mysuru", "Hubballi", "Mangaluru", "Belagavi", 
      "Davangere", "Bellary", "Shimoga", "Tumakuru", "Gulbarga", 
      "Bidar", "Bijapur", "Hospet", "Udupi", "Hassan", "Raichur",
      "Bagalkot", "Ranibennur", "Chikmagalur", "Chitradurga"
    ],
    "Kerala": [
      "Kochi", "Thiruvananthapuram", "Kozhikode", "Thrissur", "Kollam", 
      "Alappuzha", "Palakkad", "Malappuram", "Kannur", "Kottayam", 
      "Kasaragod", "Pathanamthitta", "Manjeri", "Thalassery", "Vatakara"
    ],
    "Madhya Pradesh": [
      "Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain", 
      "Sagar", "Dewas", "Satna", "Ratlam", "Rewa", "Murwara", 
      "Singrauli", "Khandwa", "Burhanpur", "Bhind", "Chhindwara",
      "Guna", "Shivpuri", "Vidisha", "Damoh"
    ],
    "Maharashtra": [
      "Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Aurangabad", 
      "Navi Mumbai", "Solapur", "Kolhapur", "Amravati", "Nanded", 
      "Sangli", "Malegaon", "Akola", "Latur", "Dhule", "Ahmednagar", 
      "Chandrapur", "Parbhani", "Jalgaon", "Ichalkaranji", "Jalna",
      "Satara", "Beed", "Yavatmal", "Gondia", "Wardha"
    ],
    "Odisha": [
      "Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur", "Puri", 
      "Balasore", "Bhadrak", "Baripada", "Berhampur", "Jharsuguda"
    ],
    "Punjab": [
      "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", 
      "Mohali", "Hoshiarpur", "Pathankot", "Moga", "Abohar", 
      "Khanna", "Phagwara", "Muktsar", "Barnala", "Firozpur"
    ],
    "Rajasthan": [
      "Jaipur", "Jodhpur", "Kota", "Udaipur", "Ajmer", 
      "Bikaner", "Bhilwara", "Alwar", "Sikar", "Sri Ganganagar", 
      "Bharatpur", "Pali", "Tonk", "Baran", "Hanumangarh", "Beawar"
    ],
    "Tamil Nadu": [
      "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", 
      "Tirunelveli", "Tiruppur", "Erode", "Vellore", "Thoothukudi", 
      "Nagercoil", "Thanjavur", "Dindigul", "Cuddalore", "Kanchipuram",
      "Ambur", "Karaikudi", "Kumbakonam", "Neyveli", "Pudukkottai"
    ],
    "Telangana": [
      "Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam", 
      "Ramagundam", "Secunderabad", "Mahbubnagar", "Nalgonda", "Adilabad", 
      "Suryapet", "Miryalaguda", "Siddipet", "Jagtial", "Mancherial"
    ],
    "Uttar Pradesh": [
      "Noida", "Lucknow", "Kanpur", "Ghaziabad", "Agra", 
      "Varanasi", "Meerut", "Allahabad", "Bareilly", "Aligarh", 
      "Moradabad", "Saharanpur", "Gorakhpur", "Jhansi", "Firozabad", 
      "Loni", "Muzaffarnagar", "Mathura", "Rampur", "Shahjahanpur",
      "Hapur", "Faizabad", "Farrukhabad", "Mirzapur", "Rae Bareli"
    ],
    "Uttarakhand": ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rishikesh", "Kashipur", "Rudrapur", "Pithoragarh", "Ramnagar"],
    "West Bengal": [
      "Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri", 
      "Kharagpur", "Bardhaman", "Malda", "Baharampur", "Habra", 
      "Jalpaiguri", "Shantipur", "Dankuni", "Ranaghat", "Haldia"
    ]
  },
  "United States": {
    "California": [
      "Los Angeles", "San Francisco", "San Jose", "San Diego", "Sacramento", 
      "Oakland", "Fresno", "Long Beach", "Bakersfield", "Anaheim", "Santa Ana",
      "Riverside", "Stockton", "Chula Vista", "Irvine", "Fremont"
    ],
    "New York": [
      "New York City", "Buffalo", "Rochester", "Yonkers", "Albany", 
      "Syracuse", "New Rochelle", "Mount Vernon", "Schenectady", "Utica"
    ],
    "Texas": [
      "Houston", "San Antonio", "Dallas", "Austin", "Fort Worth", 
      "El Paso", "Arlington", "Corpus Christi", "Plano", "Laredo",
      "Lubbock", "Garland", "Irving", "Amarillo", "Grand Prairie"
    ],
    "Florida": [
      "Miami", "Tampa", "Orlando", "Jacksonville", "Tallahassee", 
      "St. Petersburg", "Hialeah", "Port St. Lucie", "Cape Coral", "Fort Lauderdale"
    ],
    "Illinois": [
      "Chicago", "Aurora", "Rockford", "Joliet", "Naperville", 
      "Springfield", "Peoria", "Elgin", "Waukegan", "Cicero"
    ]
  },
  "United Arab Emirates": {
    "Abu Dhabi": ["Abu Dhabi", "Al Ain", "Ruwais", "Ghayathi", "Liwa Oasis"],
    "Dubai": ["Dubai", "Hatta", "Jebel Ali"],
    "Sharjah": ["Sharjah", "Khor Fakkan", "Kalba", "Dibba Al-Hisn", "Dhaid"],
    "Ajman": ["Ajman", "Masfout", "Manama"],
    "Fujairah": ["Fujairah", "Dibba Al-Fujairah", "Qidfa"],
    "Ras Al Khaimah": ["Ras Al Khaimah", "Al Jazirah Al Hamra", "Rams"],
    "Umm Al Quwain": ["Umm Al Quwain", "Falaj Al Mualla"]
  }
};
